<mat-card appearance="outlined" class="m-2">
    <div class="row text-center">
        <h1 class="parent-title">{{titleTwo}}</h1>
         <!-- <mat-icon>{{icon}}</mat-icon>  -->
    </div>
    <div [ngClass]="titleOne.length == 1 ? 'row d-flex justify-content-center' : 'row d-flex justify-content-between'">
        <div *ngFor = "let item of titleOne; let i = index" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                <h2 class="chip-title">{{item['category']}}</h2>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                <div class="center d-flex align-items-center justify-content-center" tooltip = "{{createToolTip(item['status'])}}" placement = "bottom" [ngClass] = "titleTwo == 'Today' ? 'color-today' : titleTwo == 'This Month' ? 'color-month' : titleTwo == 'This Week' ? 'color-week' : ''">
                    <p class="count-style">{{item['meetingCount']}}</p>
                </div>
            </div>
        </div>
    </div>
</mat-card>
